const HeaderScroll = () => {
	const header = document.getElementById('the-header');
	const fullscreenCover = document.querySelector('.wp-block-cover-wrapper.is-style-fullscreen');

	if (!header || !fullscreenCover) {
		return;
	}

	const render = () => {
		const currentScroll = window.scrollY || document.documentElement.scrollTop;
		const coverBottom = fullscreenCover.offsetTop + fullscreenCover.offsetHeight;

		if (currentScroll > coverBottom) {
			header.classList.add('js-scrolled-state');
		} else {
			header.classList.remove('js-scrolled-state');
		}
	};

	// Initialize
	header.classList.add('js-initialized');
	window.addEventListener('scroll', render);
	render();

	// Return cleanup function
	return () => {
		window.removeEventListener('scroll', render);
	};
};

export default HeaderScroll;
